<template>
  <div class="homepage">

    <input type="hidden" id="longitude" value="">
    <input type="hidden" id="latitude" value="">
    <input type="hidden" id="duty_status" value="">
    <input type="hidden" id="screen" value="">
    <section class="toolbar">
      <div class="toolbar-container">
        <div id="mySidenav" v-on:click.stop="closeNav()" class="sidenav">
          <div class="sidenav-container">
            <div class="sidenav-profile">
              <div class="user-profile">
                <img src="/static/images/user-profile.png">
              </div>
              <div class="user-profile-info">
                <span>
                  <!--<router-link v-bind:to="'/operator/profile'">{{ fname }} {{ lname }}</router-link>-->
                  {{ fname }} {{ lname }}
                </span>
                <!--<p>My Account</p>-->
              </div>
            </div>
            <!--<a href="#"><img src="/static/images/drive-log.png">Driver Log</a>-->
            <router-link id="user-profile" v-bind:to="'/operator/profile'">
              <span class="glyphicon glyphicon-user"></span>Profile</router-link>
            <router-link id="cycle-rule-set-page" v-bind:to="'/operator/cyclerules'"><img src="/static/images/cycle-icon.png">Cycle Rules</router-link>
            <router-link id="sendlogs-mailer-page" v-bind:to="'/operator/sendlogs'">
              <span class="glyphicon glyphicon-send"></span>Send Logs</router-link>
            <template v-if="isSafety == 1">
              <router-link id="add-company-page" v-bind:to="'/operator/addcompany'"><img src="/static/images/company.png">Company</router-link>
              <router-link id="add-asset-page" v-bind:to="'/asset/addasset'"><img src="/static/images/asset.png">Asset</router-link>
            </template>
            <router-link id="about-page" v-bind:to="'/operator/about'">
              <span class="glyphicon glyphicon-info-sign"></span>FAQ/Support</router-link>
            <router-link id="logout-click" v-bind:to="'/operator/logout'" v-on:click="logout()"><img src="/static/images/logout.png">Logout</router-link>
          </div>
        </div>
        <span style="cursor:pointer" v-on:click="openNav()"><img id="home-page-sidebar" src="/static/images/menu.png"></span>
        <h1>Logs</h1>
        <div v-show="isSetCycleRule" class="hos-container">
          <button id="HOS-button" type="button" class="btn btn-info btn-lg" data-toggle="modal" data-target="#cycleModal"><img src="/static/images/hos.png"></button>
        </div>
      </div>
    </section>

    <div class="clearfix"></div>
    <section class="duty-section duty-section-new-block">

      <div class="duty-container">

        <div id="change-duty-status-tab" class="duty-container-left" v-on:click="navigateToChangeDuty()">
          <div class="duty-status">
            <a href="javascript:void(0)" class="active">{{globalStatusSym}}</a>
          </div>
          <h4 class="small-text">Current Status</h4>
          <h3 class="large-text">{{globalStatusAttrib}}</h3>
        </div>
        <!--<div class="duty-container-right">
                        
                                            <div class="duty-status">                          
                                                <a href="javascript:void(0)" class="duty-off" v-bind:class="{active : statusOFF}" v-on:click="changeDuty('off')">Off</a>
                                                <a href="javascript:void(0)" class="duty-sb" v-bind:class="{active : statusSB}" v-on:click="changeDuty('sb')">SB</a>
                                                <a href="javascript:void(0)" class="duty-on" v-bind:class="{active : statusON}" v-on:click="changeDuty('on')">On</a>            
                                            </div>                        
                                            <div class="arrow-right">
                                                <router-link v-bind:to="'/asset/inspection'" ><img src="/static/images/inspection.png"></router-link>                            
                                            </div>
                        
                                        </div>-->
        <div id="inspection-tab" class="duty-container-right" v-on:click="showDateLog(frontEndDateFormat(currentDateInLocal), frontEndDateFormat(currentDateInLocal) + ' 00:00:00', currentDateInLocal)">
          <div class="arrow-right">
            <!--<router-link v-bind:to="'/asset/pre-log-summary?selected_date='+ showDateLog(formatDate())" >-->
            <a href="javascript:void(0)">
              <p><img src="/static/images/inspection-gray.png"></p>
              <span>Inspection</span>
            </a>
            <!--</router-link> -->
          </div>
        </div>
      </div>

    </section>

    <div class="clearfix"></div>

    <section class="start-container">

      <div class="start-status">Today</div>
      <div class="start-position light-img">
        <img src="/static/images/eld-white.png">
      </div>
      <div class="col-md-6 err-msg pull-right"></div>
      <div class="current-vehicle-container">

        <div class="current-vehicle-container-left">
          <span>Current Vehicle</span>
          <p>{{ selected_vehicle }}</p>
        </div>

        <div class="current-vehicle-container-right">

          <a v-if="selected_vehicleBLANK" href="javascript:void(0)" v-on:click="displayMsg()">Start</a>
          <router-link v-else-if="statusDRIVING" v-bind:to="'/operator/log-timer'" id="driver-in-motion">In Motion</router-link>
          <a v-else-if="statusSTARTED" href="javascript:void(0)" class="start-btn" v-on:click="changeDuty('driving')" id="driver-start-driving">Start</a>
          <div v-else class="shift-not-started"> start your shift first</div>
        </div>

      </div>

    </section>

    <section class="list-view">
      <div class="list-view-title">
        <h2>Last 7 Days</h2>
      </div>
      <div class="list-container">
        <ul v-if="logs">
          <li v-for="val in logdata" v-on:click="showDateLog(val.OriginalDate, val.OriginalDate + ' 00:00:00', val.OriginalDate + ' 23:59:59')">
            <div class="list-view-left">{{ val.Date }}
              <h4 class="small-text">{{ val.NoOfInspections }}</h4>
            </div>
            <div class="list-view-right"><img src="/static/images/clock.png">{{ val.Time }}</div>
          </li>
        </ul>
        <ul v-else>
          <li>
            <div class="list-view-left">No Log Found</div>
          </li>
        </ul>
        <!-- last 7 days log hours-->
      </div>
    </section>
    <div class="modal fade hos-popup" id="cycleModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{ cycleName }}</h4>
          </div>
          <div class="modal-body">
            <div class="hos-listing">
              <div class="hos-diagram-container">
                <div class="circle" id="break_time_circle">
                  <strong>07:27<br/>
                    <span>Break</span>
                  </strong>
                </div>
                <div class="circle" id="cycle_hours_circle">
                  <strong>{{ cycleHours }}<br/>
                    <span>Cycle</span>
                  </strong>
                </div>
                <div class="circle" id="shift_time_circle">
                  <strong>{{ cycleShiftTime }}<br/>
                    <span>Shift</span>
                  </strong>
                </div>
                <div class="circle" id="drive_time_circle">
                  <strong>{{ cycleDriveTime }}<br/>
                    <span>Drive</span>
                  </strong>
                </div>
              </div>
              <div class="hos-recap">
                Hos Recap
              </div>
              <div class="list-container">
                <ul v-if="hos">
                  <template v-for="val in hosData">
                    <template v-if="val.OriginalDate === currentDate">
                      <div class="restart-label">
                        {{ cycleRestartHour }} Hours Restart on {{ cycleRestartDate }}
                      </div>
                    </template>
                    <li>
                      <div class="list-view-left">{{ val.Date }}</div>
                      <div class="list-view-right">{{ val.Time }}</div>
                    </li>
                  </template>
                </ul>
                <ul v-else>
                  <li>
                    <div class="list-view-left">No HOS Found</div>
                  </li>
                </ul>
              </div>

              <!--<div class="list-container">
                                <ul>                  
                                  <li>
                                    <div class="list-view-left">Saturday
                                      <span>Jan 20</span>
                                    </div>
                                    <div class="list-view-right">0.00
                                    </div>
                                  </li>
                                </ul>
                              </div>-->
              <div class="list-container">
                <ul class="list-container-bg">
                  <li>
                    <div class="list-view-left">Total Hours Since Restart </div>
                    <div class="list-view-right">{{ totalHoursSpent }}
                    </div>
                  </li>
                  <li>
                    <div class="list-view-left">Hours Available Today </div>
                    <div class="list-view-right">{{ hoursAvailToday }}
                    </div>
                  </li>
                  <li>
                    <div class="list-view-left">Hours Worked Today </div>
                    <div class="list-view-right">{{ hoursWorkedToday }}
                    </div>
                  </li>
                  <li>
                    <div class="list-view-left">Hours Available Tomorrow </div>
                    <div class="list-view-right">{{ hoursAvailTomorrow }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-loading" v-if="this.$config.loading">
      <div class="custom-loading-box">
        <i class="fa fa-truck faa-passing-reverse animated " aria-hidden="true"></i>
      </div>
    </div>
    </body>
  </div>
  </div>
</template>

<script>
// import bootstrap from 'bootstrap'
// import getLocationConstant from "../static/js/vtrleld.js";
// import onGeoSuccess from "../static/js/vtrleld.js";
// import onGeoError from "../static/js/vtrleld.js";
// import changeDutystatus from "../static/js/vtrleld.js";
var intervalD = 0;
export default {
  name: "homepage",
  template: "#homepage",
  data: () => ({
    fname: "",
    lname: "",
    globalStatus: "",
    globalStatusSym: "",
    globalStatusAttrib: "",
    statusOFF: false,
    statusSB: false,
    statusON: false, // for ON or DRIVING state
    statusDRIVING: false,
    selected_vehicle: "",
    selected_vehicleBLANK: false,
    logs: true,
    logdata: [],
    hos: true,
    hosData: [],
    isSetCycleRule: false,
    cycleDriveTime: 0,
    cycleShiftTime: 0,
    cycleName: "",
    cycleHours: 0,
    driveTimePerc: 0,
    shiftTimePerc: 0,
    cycleHourPerc: 0,
    currentDate: "",
    cycleRestartHour: 0,
    cycleRestartDate: "",
    totalHoursSpent: "00:00",
    hoursAvailToday: "00:00",
    hoursWorkedToday: "00:00",
    hoursAvailTomorrow: "00:00",
    currentDateInLocal: "",
    statusSTARTED: true,
    isSafety: 0,
    disableControls: false,
    userAgent: "",
  }),
  mounted: function() {
    this.getUserAgent();
    this.call();
    // this.call2();
    var self = this;
    intervalD = setInterval(function() {
      //var self = this;
      self.getELDStatus(self.globalStatus);
    }, 60000);
    if (self.userAgent == "vtrleld_app") {
      Native.enableSwipeRefresh();
    }
  },
  beforeDestroy: function() {
    clearInterval(intervalD);
  },
  methods: {
    getUserAgent: function() {
      this.userAgent = navigator.userAgent;
      console.log("UserAgent : " + this.userAgent);
    },
    getLocationConstant: function(flag) {
      var self = this;
      if (navigator.geolocation) {
        var abc = navigator.geolocation.getCurrentPosition(
          self.onGeoSuccess,
          self.onGeoError
        );
      } else {
      }
    },

    onGeoSuccess: function(event) {
      var self = this;
      //document.getElementById("location").value =  event.coords.latitude+", "+event.coords.longitude;
      $("#longitude").val(event.coords.longitude);
      $("#latitude").val(event.coords.latitude);
      self.changeDutystatus(event.coords.latitude, event.coords.longitude);
    },

    onGeoError: function(event) {
      var self = this;
      this.changeDutystatus("", "");
    },
    frontEndDateFormat: function(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    },
    changeDutystatus: function(latitude, longitude) {
      var self = this;
      var status = $("#duty_status").val();
      var screen = $("#screen").val();
      self.$config.loading = true;
      $.ajax({
        url: self.$config.API + "/v1/operator/change-duty-status",
        type: "POST",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        timeout: 10000,
        data: { status: status, latitude: latitude, longitude: longitude },
        success: function(data) {
          self.$config.loading = false;
          //enable screen
          $(".loading").addClass("hide");

          if (screen == "home") {
            $(".duty-status a").removeClass("active");
            if (data.status == "success") {
              $(".duty-status")
                .find(".duty-" + status)
                .addClass("active");

              if (status == "driving") {
                $(".start-btn").prop("disabled", false);
                self.$router.push("/operator/log-timer");
              }
            } else {
              if (status == "driving") {
                $(".start-btn").prop("disabled", false);
              }
            }
          } else {
            if (data.status == "success") {
              if (status == "sb") {
                $(".pause-btn").prop("disabled", false);
                $(".pause-btn").addClass("hide");
                $(".start-btn").removeClass("hide");
              }
              if (status == "driving") {
                $(".start-btn").addClass("hide");
                $(".pause-btn").removeClass("hide");
              }
              if (status == "off") {
                self.$router.push("/v1/operator/log-summary");
                //window.location="/v1/operator/home-page";
              }
            } else {
            }
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          //if session expired
          if (textstatus === "timeout") {
            alert("got timeout");
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/operator/login");
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.messge);
          }
        }
      });
    },
    // Load last 7 days logs
    loadLogs: function() {
      var self = this;
      $.ajax({
        url: self.$config.API + "/v1/operator/last-seven-days-logs",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        dataType: "json",
        success: function(res) {
          self.$config.loading = false;
          //debugger
          var data = res.data;
          //console.log(data);
          if (res.status == "success") {
            if (data.logs != null && data.logs.length > 0) {
              self.logdata = data.logs;
            } else {
              self.logs = false;
            }
            //check HOS data
            if (data.hos != null && data.hos.length > 0) {
              self.hosData = data.hos;
            } else {
              self.hos = false;
            }

            //set current date
            self.currentDate = data.current_date;
            self.cycleRestartDate = data.hos_restart_date;
            self.totalHoursSpent = data.total_hours_since_restart;
            self.hoursAvailToday = data.total_hours_avail_today;

            self.driveTimePerc = data.driving_percentage;
            self.cycleDriveTime = data.today_drive_time;

            $("#drive_time_circle").circleProgress({
              value: self.driveTimePerc / 100,
              fill: {
                color: "#8bc53f"
              }
            });

            self.shiftTimePerc = data.shift_percentage;
            self.cycleShiftTime = data.today_shift_time;

            $("#shift_time_circle").circleProgress({
              value: self.shiftTimePerc / 100,
              fill: {
                color: "#4fa2d0"
              }
            });
            self.hoursWorkedToday = data.hours_worked_today;
            self.hoursAvailTomorrow = data.hours_avail_tomorrow;

            self.cycleHours = data.hours_avail_tomorrow;
            self.cycleHourPerc = data.cycle_percentage;
            $("#cycle_hours_circle").circleProgress({
              value: self.cycleHourPerc / 100,
              fill: {
                color: "#787878"
              }
            });
          } else if (res.status == "error") {
             self.logs = false;
             alert(res.message);
             self.$router.push("/operator/cyclerules");
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.message);
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/operator/login");
          }
        }
      });
    },

    getELDStatus: function(duty_status) {
      var self = this;
      if (
        duty_status == "on" ||
        duty_status == "sb" ||
        duty_status == "driving"
      ) {
        $.ajax({
          url: self.$config.API + "/v1/assets/get-current-status",
          type: "GET",
          crossDomain: true,
          async: true,
          xhrFields: {
            withCredentials: true
          },
          success: function(data) {
            if (data.status == "success") {
              $(".start-position").removeClass("light-img");
            } else {
              $(".start-position").addClass("light-img");
            }
          },
          error: function(jqXHR, exception) {
            //if session expired
            if (jqXHR.responseJSON.code == 401) {
              self.$router.push("/operator/login");
            } else {
              //console.log(jqXHR.responseJSON.message)
            }
          }
        });
      }
    },

    selectAsset: function(selected_vehicle) {
      //var asset = document.getElementById('asset').value;
      this.$router.push(
        "/v1/assets/asset-selection?selected_vehicle=" + selected_vehicle
      );
    },

    changeDuty: function(status) {
      if (this.disableControls) {
        alert("Please select an Asset First");
      } else {
        var self = this;
        if (status == "driving") {
          $(".start-btn").prop("disabled", true);
        }

        //make empty last location
        $("#longitude").val("");
        $("#latitude").val("");
        $("#duty_status").val("");
        $("#screen").val("");

        $("#duty_status").val(status);
        $("#screen").val("home");

        //disable screen on button click
        //$("body").addClass("overlay");
        //get location of operator
        // $(".loading").removeClass("hide");
        self.getLocationConstant();

        if (self.userAgent == "vtrleld_app") {
          Native.startLocationServices();
        }
        // $('.duty-status a').removeClass('active');
        //     if ( data.message == "Success") {

        //         $('.duty-status').find('.duty-'+status).addClass('active');

        //         if ( status == "driving") {
        //             $('.start-btn').prop('disabled', false);
        //             window.location="/v1/operator/log-timer";
        //         }

        //     } else {
        //         if ( status == "driving") {
        //             $('.start-btn').prop('disabled', false);
        //         }
        //         console.log("error")
        //     }
      }
    },
    navigateToChangeDuty: function() {
      if (this.disableControls) {
        alert("Please select an Asset First");
      } else {
        this.$router.push(
          "/operator/changedutystatus?current_status=" + this.globalStatus
        );
      }
    },
    displayMsg: function() {
      $(".err-msg")
        .text("select vehicle")
        .css("color", "white");
    },

    closeNav: function() {
      document.getElementById("mySidenav").style.width = "0";
      $("body").css({
        overflow: "visible"
      });
    },

    openNav: function() {
      document.getElementById("mySidenav").style.width = "100%";
      // document.getElementsByTagName("body").style.width = "100%";
      $("body").css({
        overflow: "hidden"
      });
    },
    showDateLog: function(originalDate, fromDate, toDate) {
      if (this.disableControls) {
        alert("Please select an Asset First");
      } else {
        var self = this;
        //alert(originalDate);
        this.$router.push(
          "/operator/pre-log-summary?selected_date=" +
          originalDate +
          "&from_date=" +
          fromDate +
          "&to_date=" +
          toDate
        ); // window.location = "/v1/operator/pre-log-summary?date=" + originalDate;
      }
    },
    formatDate: function() {
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    call2: function() {
      var self = this;
      $.ajax({
        url: self.$config.API + "/v1/operator/change-duty-status",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function(data) {
          console.log(data);
          if ((data.status == "success") && (data.data.stop_pressed == true)) {
            self.$config.loading = false;
            self.statusSTARTED = false;
            //self.showAlertBeforeStart=data.data.show_alert;
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          //  if(textstatus==="timeout") {
          //             alert("Request timeout");
          //         } else {
          //             alert(textstatus);
          //         }
        }
      });
    },
    call: function() {
      var self = this;
      self.$config.loading = true;
      $.ajax({
        url:
        self.$config.API +
        "/v1/operator/home-page?selected_vehicle=" +
        self.$route.query.selected_vehicle +
        "&vin=" +
        self.$route.query.vin,
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        timeout: 10000,
        success: function(res) {
          var data = res.data.homeData;
          console.log(res.data.is_safety);
          self.currentDateInLocal = res.data.current_local_date;
          console.log(self.currentDateInLocal);
          self.fname = data.fname;
          self.lname = data.lname;
          self.globalStatus = data.status;
          if (self.globalStatus == "on" || self.globalStatus == "start") {
            self.globalStatusSym = "ON";
            self.globalStatusAttrib = "ON DUTY";
            self.globalStatus = "on";
          } else if (self.globalStatus == "sb") {
            self.globalStatusSym = "SB";
            self.globalStatusAttrib = "SLEEPER";
          } else if (self.globalStatus == "off") {
            self.globalStatusSym = "OFF";
            self.globalStatusAttrib = "OFF DUTY";
          } else if (self.globalStatus == "stop") {
            // self.statusSTOP = false;
            self.globalStatusSym = "OFF";
            self.globalStatusAttrib = "OFF DUTY";
          } else {
            self.globalStatusSym = "ON";
            self.globalStatusAttrib = "DRIVING";
          }
          self.isSafety = res.data.is_safety;
          self.selected_vehicle = data.selected_vehicle;
          if (self.selected_vehicle == "") {
            self.disableControls = true;
          }
          //console.log(data);
          //console.log("**********");
          if (self.globalStatus == "off") {
            self.statusOFF = true;
          } else if (self.globalStatus == "sb") {
            self.statusSB = true;
          } else if (
            self.globalStatus == "on" ||
            self.globalStatus == "driving"
          ) {
            if (self.globalStatus == "driving") {
              self.statusDRIVING = true;
            }
            self.statusON = true;
          }
          //debugger
          // self.loadLogs();

          var sftDetail = res.data.shiftDetail;
          if (sftDetail == null) {
            self.isSetCycleRule = false;
          } else {
            self.isSetCycleRule = true;
            self.cycleName = sftDetail[0].shift_name;
            self.cycleDriveTime = sftDetail[0].drive_time + ":00";
            self.cycleShiftTime = sftDetail[0].shift_time + ":00";
            self.cycleHours = sftDetail[0].hours + ":00";
            self.cycleRestartHour = sftDetail[0].restart_hour;

            self.driveTimePerc = convertToPercentage(
              sftDetail[0].drive_time,
              0
            );
            self.shiftTimePerc = convertToPercentage(
              sftDetail[0].shift_time,
              0
            );
            self.cycleHourPerc = convertToPercentage(sftDetail[0].hours, 0);

            var progressBarOptions = {
              startAngle: -1.55,
              size: 120,
              value: 0.75,
              fill: {
                color: "#047abc"
              }
            };

            $(".circle")
              .circleProgress(progressBarOptions)
              .on("circle-animation-progress", function(
                event,
                progress,
                stepValue
              ) {
                //$(this).find('strong').text(String(stepValue.toFixed(2)).substr(1));
              });

            $("#break_time_circle").circleProgress({
              value: 0.25,
              fill: {
                color: "#8bc53f"
              }
            });

            $("#drive_time_circle").circleProgress({
              value: self.driveTimePerc,
              fill: {
                color: "#8bc53f"
              }
            });

            $("#shift_time_circle").circleProgress({
              value: self.shiftTimePerc,
              fill: {
                color: "#4fa2d0"
              }
            });

            $("#cycle_hours_circle").circleProgress({
              value: self.cycleHourPerc,
              fill: {
                color: "#787878"
              }
            });
          }
          self.loadLogs();
          self.call2();
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          //if session expired
          if (textstatus === "timeout") {
            alert("Request timeout");
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/operator/login");
          } else {
            alert("There is some error occurred. Please try again later");
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homepage.vue